<template>
  <iframe ref="iframeSelfCrtfcRef" style="width: 0; height: 0;" />
</template>

<script setup>
import {ref, defineExpose, onMounted, defineEmits} from "vue";

const emits = defineEmits(['callback']);

const iframeSelfCrtfcRef = ref();
const showSelfCrtfc = () => {
  iframeSelfCrtfcRef.value.src = '';
  iframeSelfCrtfcRef.value.src = '/api/niceid-selfcrtfc/main';
  const messageListner = function(event) {
    const isSelfCrtfc = event.data.sccsAt == 'Y'?true:false;
    const result = {
      isSelfCrtfc
    }

    if (isSelfCrtfc) {
      let mbpnTlno = event.data.sMobileNo;

      const cleaned = mbpnTlno.replace(/\D/g, '');
      mbpnTlno = cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      if (cleaned.length === 11) mbpnTlno = cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
      result.nm = event.data.sName;
      result.bthd = event.data.sBirthDate;
      result.mbpnTlno = mbpnTlno;
    } else {
      result.errCd = event.data.sErrorCode;
      result.errMssg = event.data.sMessage;
    }

    emits('callback', result);
    window.removeEventListener('message', messageListner);
  };
  window.addEventListener('message', messageListner);
}

defineExpose({
  showSelfCrtfc
});

onMounted(() => {
})
</script>

<style scoped>

</style>
